// extracted by mini-css-extract-plugin
export default {"title":"PackagePayment_title__ihsMu","list-plan":"PackagePayment_list-plan__0DQUD"};